import { Button, Typography } from '@mui/material';
import './Orientacoes2.scss';

import { useAtom } from 'jotai';
import { FC, useEffect, useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { accessToken } from '../../atoms/atom';

const Orientacoes2: FC = () => {
	const { id } = useParams<{ id: string }>();
	const [accessTokenAtom] = useAtom(accessToken);
	const isMounted = useRef(true);
	const navigate = useNavigate();

	const next = () => {
		navigate(`/${id}/pergunta`);
	}

	useEffect(() => {
		const token = accessTokenAtom || localStorage.getItem("access-token");
		if (!token && isMounted.current) {
			navigate(`/${id}/login`);
		}
	}, [accessTokenAtom]);

	return (
		<div className="orientations2">
			<div className="orientations-data2">
				<Typography variant='subtitle2' align='justify'>
					Agora, responda conforme a seguinte escala:
				</Typography>
				<p style={{textAlign:"left", width:"100%"}}>1 - <b>☹️ - Nada/quase nada</b></p>
				<p style={{textAlign:"left", width:"100%"}}>2 - <b>🙁 - Um pouco</b></p>
				<p style={{textAlign:"left", width:"100%"}}>3 - <b>😐 - Moderadamente</b></p>
				<p style={{textAlign:"left", width:"100%"}}>4 - <b>🙂 - Muito</b></p>
				<p style={{textAlign:"left", width:"100%"}}>5 - <b>😀 - Extremamente</b></p>
			</div>
			<Button onClick={() => next()} variant='contained' color='primary' size='large'>
				Continuar
			</Button>
		</div>
	)
}

export default Orientacoes2;